import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { DS } from '../../ds';
interface Crumb {
  label: string;
  to?: string;
}
interface BlogBreadcrumbProps {
  items: Crumb[];
}
export function BlogBreadcrumb({
  items
}: BlogBreadcrumbProps) {
  const navigate = useNavigate();
  return <nav aria-label="Ruta de navegación" style={{
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${DS.color.border}`,
    fontFamily: DS.font.body,
    fontSize: '13px'
  }} data-id="element-278" data-mp="1i85d8ibviixj">
      {items.map((item, index) => <Fragment key={`${item.label}-${index}`} data-id="element-279" data-mp="20y4wgol193t1" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" style={{
        color: DS.color.border
      }} data-id="element-280" data-mp="kkwv8xb2zs0a">
              /
            </span>}
          {item.to ? <button type="button" onClick={() => navigate(item.to as string)} style={{
        background: 'transparent',
        border: 'none',
        padding: 0,
        color: DS.color.teal,
        fontWeight: 700,
        fontSize: '13px',
        cursor: 'pointer',
        fontFamily: DS.font.body
      }} data-id="element-281" data-mp="plklhgrhk4tg">
              {item.label}
            </button> : <span style={{
        color: DS.color.muted
      }} data-id="element-282" data-mp="98905tos5ys9">{item.label}</span>}
        </Fragment>)}
    </nav>;
}